export const environment = {
  production: true
};



// WEBPACK FOOTER //
// /var/www/html/project/snsina/src/environments/environment.ts